exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.input[data-v-2c06171a] {\n  width: 200px;\n}\n", ""]);

// exports
